<div class="modal-content modal-custom">
  <div class="col-12">
    <form class="box-form p-5" [formGroup]="formToken">
      <h3 class="form-title text-center">Validar E-Mail</h3>
      <hr>
      <div class="form-row mt-5 ">
        <h4 class="subtitle-form text-center col-12">Um código (número de 6 dígitos) foi enviado por E-mail informado anteriormente.</h4>
      </div>
      <div class="form-row mt-4">
        <div class="col-md">
          <h3 class="title-email">
            Digite abaixo o código recebido por E-mail:
          </h3>
       </div>
      </div>

       <div class="form-row mt-5 d-flex justify-content-center">
         <div class="col-md-7">
           <div class="form-outline">
             <input data-testid="token-validar-email" type="text" [dropSpecialCharacters]="true" formControlName="token" placeholder="Digite o código recebido por E-mail" mask=" 0   0   0   0   0   0 " class="form-control text-center">
               <span class="error-form ml-2" *ngIf="tokenFornecido.invalid && (tokenFornecido.dirty || tokenFornecido.touched)">Campo obrigatório.</span>
            </div>
         </div>
      </div>

      <div class="form-row mt-5 d-flex justify-content-center">
        <div class="col-md text-center">
          <span data-testid="botao-reenviar-token" class="reenviar-codigo" (click)="enviarTokenEmail()">Reenviar código por email</span>
        </div>
      </div>

      <div class="form-row mt-3 d-flex justify-content-center">
        <div class="col-md text-center">
          <button data-testid="botao-validar-email" class="btn" (click)="validateEmail()">Validar Token</button>
        </div>
      </div>
    </form>
  </div>
</div>
